<template>
  <button
    ref="triggerButton"
    class="support-ticket-button"
    :class="`support-ticket-button--${variant}`"
    type="button"
    title="Contacter le support"
    aria-label="Contacter le support"
    aria-controls="support-ticket-rightbar"
    :aria-expanded="rightbarVisible ? 'true' : 'false'"
    @click="openRightbar"
  >
    <i class="fa fa-headset" aria-hidden="true"></i>
  </button>

  <SupportTicketRightbar
    v-model:visible="rightbarVisible"
    :module-options="moduleOptions"
    :variant="variant"
    @after-hide="restoreTriggerFocus"
  />
</template>

<script>
import { defineComponent } from 'vue';
import SupportTicketRightbar from '@/components/SupportTicketRightbar.vue';

export default defineComponent({
  name: 'SupportTicketButton',
  components: { SupportTicketRightbar },
  props: {
    moduleOptions: { type: Array, default: undefined },
    variant: { type: String, default: 'admin' },
  },
  data() {
    return { rightbarVisible: false };
  },
  methods: {
    openRightbar() {
      this.rightbarVisible = true;
    },
    restoreTriggerFocus() {
      this.$nextTick(() => this.$refs.triggerButton?.focus());
    },
  },
});
</script>

<style scoped>
.support-ticket-button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: #fff;
  display: inline-flex;
  flex: 0 0 auto;
  height: 34px;
  justify-content: center;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
  width: 34px;
}

.support-ticket-button i { font-size: 1.15rem; }

.support-ticket-button:hover,
.support-ticket-button:focus-visible {
  background-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 0 0.16rem rgba(255, 255, 255, 0.18);
  color: #fff;
  transform: translateY(-2px);
}

.support-ticket-button:hover i,
.support-ticket-button:focus-visible i { animation: support-ticket-pulse 0.5s ease-in-out; }

@keyframes support-ticket-pulse {
  0%, 100% { transform: scale(1) rotate(0); }
  35% { transform: scale(1.12) rotate(-8deg); }
  70% { transform: scale(1.06) rotate(6deg); }
}

@media (prefers-reduced-motion: reduce) {
  .support-ticket-button { transition: none; }
  .support-ticket-button:hover i,
  .support-ticket-button:focus-visible i { animation: none; }
}
</style>
